import { FrequentTransactions, FrequentTransaction, Transaction, TransactionType } from '@algoan/dashboard/model';
import { sumTransactionsAmount } from '@algoan/dashboard/utils';

const filterFrequentTransactions = (
  frequentTransactions: FrequentTransactions[],
  transactions: Transaction[],
  minimumNumberOfTransactionsToDisplayFrequentTransactions: number,
): FrequentTransactions[] =>
  frequentTransactions.filter((frequentTransaction) => {
    const cashFlowType = transactions.find(
      (transaction) =>
        frequentTransaction.transactions.map((transaction) => transaction.id).includes(transaction.id) &&
        transaction.enrichments?.type !== undefined,
    )?.enrichments?.type;

    return (
      frequentTransaction.transactions.length > minimumNumberOfTransactionsToDisplayFrequentTransactions &&
      cashFlowType !== undefined &&
      cashFlowType === TransactionType.CARD
    );
  });

export const convertFrequentTransactions = (
  transactions: Transaction[],
  minimumNumberOfTransactionsToDisplayFrequentTransactions: number,
  frequentTransactions?: FrequentTransactions[],
): FrequentTransaction[] => {
  return frequentTransactions
    ? filterFrequentTransactions(
        frequentTransactions,
        transactions,
        minimumNumberOfTransactionsToDisplayFrequentTransactions,
      ).map((frequentTransaction) => ({
        description: frequentTransaction.label,
        count: frequentTransaction.transactions.length,
        amount: sumTransactionsAmount(frequentTransaction.transactions),
        references: frequentTransaction.transactions.map((transaction) => transaction.id),
      }))
    : [];
};
